import { bumbaBoi } from '../../../../data';

export const BumbaBoiSection = () => (
  <div>
    {bumbaBoi.content.map((paragraph, index) => (
      <p key={index}>{paragraph}</p>
    ))}
  </div>
);